<div class="filters">
  <mat-form-field>
    <mat-label>Responsável</mat-label>
    <mat-select
      [formControl]="operator"
    >
      <mat-option [value]="null">Todos os Operadores</mat-option>
      <mat-option *ngFor="let item of operators" [value]="item.id">{{ item.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Cliente</mat-label>
    <mat-select
      [formControl]="business"
    >
      <mat-option [value]="null">Todas os Clientes</mat-option>
      <mat-option *ngFor="let item of businesses" [value]="item.id">{{ item.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Solicitante</mat-label>
    <mat-select
      [formControl]="businessUser"
    >
      <mat-option [value]="null">Todos os Usuários do Cliente</mat-option>
      <mat-option *ngFor="let item of businessUsers" [value]="item.id">{{ item.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Informe o Período</mat-label>
    <mat-date-range-input
      [formGroup]="range"
      [rangePicker]="picker"
    >
      <input
        matStartDate
        formControlName="start"
        placeholder="Data Inicial"
      >
      <input
        matEndDate
        formControlName="end"
        placeholder="Data Final"
      >
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <div>
    <button
      mat-flat-button
      color="primary"
      (click)="makeSearch()"
    >
      <mat-icon>search</mat-icon>
    </button>
  </div>

  <div>
    <button
      mat-stroked-button
      color="warn"
      (click)="cleanFilter()"
    >
      <mat-icon>backspace</mat-icon>
    </button>
  </div>
</div>
<div class="w-100">
  <mat-form-field class="w-100" appearance="outline">
    <input matInput [formControl]="searchControl" (ngModelChange)="searchItems($event)">
    <mat-label>Digite o trecho da descrição ou de uma resposta do chamado </mat-label>
  </mat-form-field>
</div>
